import RequireAuthContainer from "./RequireAuthContainer";

export default RequireAuthContainer;
